(function (callback) {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    callback(window, document);
  }
})(function (win, doc) {
  function log(...args) {
    console.log('[ServiceWorkerRegistration]', ...args);
  }

  function registerPwaServiceWorker(resourceCacherCallback) {
    const buildEnv = doc.documentElement.getAttribute('data-build-env');
    if (
      !buildEnv ||
      buildEnv === '{{NODE_BUILD_ENV}}' ||
      buildEnv === 'development'
    ) {
      log('Skipping registration for non-production build.');
      return;
    }

    if ('navigator' in win && 'serviceWorker' in win.navigator) {
      var registerSuccess = function (registration) {
        if (registration.installing) {
          var resourcesToCache = performance
            .getEntriesByType('resource')
            .filter(function (resource) {
              return resourceCacherCallback(resource);
            })
            .map(function (resource) {
              return resource.name;
            });

          if (resourcesToCache.length > 0) {
            registration.installing.postMessage({
              type: 'custom.RegisterCacheUrls',
              payload: resourcesToCache,
            });
          }

          log('Worker registration successful', registration.scope);
        } else {
          log(
            'Worker registration failed, no installer provided.',
            registration.scope
          );
        }
      };
      var registerFailed = function (err) {
        log('Worker registration failed', err);
      };

      win.addEventListener('load', function () {
        win.navigator.serviceWorker
          .register('/service-worker.js', { scope: '.' })
          .then(registerSuccess, registerFailed)
          .catch(registerFailed);
      });
    } else {
      console.log('Service Worker is not supported by browser.');
    }
  }

  function onReady(onReadyCallback) {
    if (doc.readyState === 'complete' || doc.readyState === 'interactive') {
      setTimeout(onReadyCallback, 0);
    } else {
      window.addEventListener('load', onReadyCallback, { once: true });
      doc.addEventListener('DOMContentLoaded', onReadyCallback, {
        once: true,
      });
    }
  }

  onReady(function () {
    const cachePatterns = [
      /fonts\.googleapis\.com/,
      /\/favicon\.ico/,
      /\/build-assets\/[a-zA-Z0-9-]+\.(css|js|png|jpg|jpeg|svg|ico)/,
      /\/assets\/[a-zA-Z0-9-]+\.(css|js|png|jpg|jpeg|svg|ico)/,
    ];

    registerPwaServiceWorker(function (resource) {
      return cachePatterns.some(function (pattern) {
        return pattern.test(resource.name);
      });
    });
  });
});
